import React from "react";
import {
  Field,
  RadioGroup,
  Radio,
  SpinButton,
  Checkbox,
} from "@fluentui/react-components";
import { CoverageComponentProps } from "./types";

const LegalProtectionCoverage: React.FC<
  CoverageComponentProps<"legalProtection">
> = ({ config, onConfigChange, t, classes }) => {
  return <>Legal Protection coverage added</>;
};

export default LegalProtectionCoverage;
